import { addDoc, collection, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { db, functions, logout } from "./_shoru_shared_library/firebase/firebase_setup";
import { v4 as uuidv4 } from 'uuid';
import PrettifyDate from "./_shoru_shared_library/functions/PrettifyDate";
import { httpsCallable } from "firebase/functions";



const setBookingEnabled = async(value, setBookingOpen, organisationId, projectId, castingData, setCastingData) => {
  const docRef = _getCastingDocRef(organisationId, projectId);
  await setDoc(docRef, {booking_enabled: value}, {merge: true}).then(() => {
    setBookingOpen(value);
    castingData.booking_enabled = value;
    setCastingData(castingData);
  });
}

const addRole = async(newRole, organisationId, projectId, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get a new copy of casting data
  await _getCastingData(docRef).then(async(castingData) => {

    // Update role with correct ID, and update the roles array
    const id = _getId(castingData.roles);
    newRole.id = id;
    const newRoles = [...castingData.roles, newRole];

    // Send new roles back to the server
    await setDoc(docRef, {roles: newRoles}, {merge: true}).then(() => {
      castingData.roles = newRoles;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.log(rejection); return false;});

  }, (rejection) => {console.log(rejection); return false;});
}

const deleteRole = async(role, organisationId, projectId, setCastingData) => {
  
  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get updated casting data
  await _getCastingData(docRef).then(async(castingData) => {

    const roleId = role.id.toString();
    var confirmBeforeDeletion = false;
    function removeRole(x) {return (x.id.toString() !== roleId)}
    function removeRecall(x) {return (x.role_id !== roleId)}

    var newSlots = castingData.slots;
    var newRoles = castingData.roles;

    newSlots.forEach((slot) => {

      var filterThisSlot = false;

      slot.notes.recall_verdicts.forEach((recall) => {
        if(recall.role_id === roleId)
        {
          if(!confirmBeforeDeletion) confirmBeforeDeletion = true;
          filterThisSlot = true;
        }
      })

      if(filterThisSlot) slot.notes.recall_verdicts = slot.notes.recall_verdicts.filter(removeRecall);

    })

    newRoles = newRoles.filter(removeRole);

    if(confirmBeforeDeletion)
    {
      if(window.confirm('There are recall groups using this role. Deleting it will remove the relevant recallees from these groups.\nAre you sure you wish to proceed?\n\n(Ok = proceed with deletion, Cancel = cancel deletion)'))
      {
        await setDoc(docRef, {slots: newSlots, roles: newRoles}, {merge: true}).then(() => {
          castingData.slots = newSlots;
          castingData.roles = newRoles;
          setCastingData(castingData);
          return true;
        }, (rejection) => {console.log(rejection); return false;});
      }
    }
    else
    {
      await setDoc(docRef, {roles: newRoles}, {merge: true}).then(() => {
        castingData.roles = newRoles;
        setCastingData(castingData);
        return true;
      }, (rejection) => {console.log(rejection); return false;});
    }

  }, (rejection) => {console.log(rejection); return false;});
  
}

const setRoles = async(newRoles, organisationId, projectId, castingData, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);

  await setDoc(docRef, {roles: newRoles}, {merge: true}).then(() => {
    castingData.roles = newRoles;
    setCastingData(castingData);
  });
}

const addTime = async(newTime, organisationId, projectId, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get a new copy of casting data
  await _getCastingData(docRef).then(async(castingData) => {

    // Update role with correct ID, and update the roles array
    const id = _getId(castingData.times);
    newTime.id = id;
    const newTimes = [...castingData.times, newTime];

    // Create new audition slots
    const newSlots = _addAuditionsFromTime(newTime, id, castingData.slots);

    // Send new roles and audition times back to the server
    await setDoc(docRef, {times: newTimes, slots: newSlots}, {merge: true}).then(() => {
      castingData.times = newTimes;
      castingData.slots = newSlots;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.log(rejection); return false;});

  }, (rejection) => {console.log(rejection); return false;});
}

const deleteTime = async(time, organisationId, projectId, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get updated casting data
  await _getCastingData(docRef).then(async(castingData) => {

    const timeId = time.id;
    var auditioneesToRemove = [];
    var newSlots = castingData.slots;
    var newTimes = castingData.times;

    function removeSlots(x) {return x.time_id !== timeId}
    function removeTime(x) {return x.id !== timeId}

    // Check if there are any booked slots in this field
    newSlots.forEach((slot) => {
      if(slot.time_id !== null)
      {
        if(slot.time_id === timeId) {
          if(slot.auditionee_id !== null) auditioneesToRemove.push(slot.auditionee_id);
        }
      }
    })

    newSlots = newSlots.filter(removeSlots);
    newTimes = newTimes.filter(removeTime);

    if(auditioneesToRemove.length > 0)
    {
      if(window.confirm('Auditionees have booked audition slots in this time. Removing it will cancel their auditions. CastingBot will NOT notify them of this.\nMake sure to notify all auditionees before proceeding.\n\n(Ok = proceed with deletion, Cancel = cancel deletion)'))
      {
        var newRoles = castingData.roles;
        auditioneesToRemove.forEach((auditioneeId) => {
          newRoles = removeUserFromChoicesForAllRoles(newRoles, auditioneeId);
        });

        await setDoc(docRef, {slots: newSlots, roles: newRoles, times: newTimes}, {merge: true}).then(() => {
          castingData.slots = newSlots;
          castingData.roles = newRoles;
          castingData.times = newTimes;
          setCastingData(castingData);
          return true;
        }, (rejection) => {console.log(rejection); return false;});
      }
    }
    else
    {
      await setDoc(docRef, {slots: newSlots, times: newTimes}, {merge: true}).then(() => {
        castingData.slots = newSlots;
        castingData.times = newTimes;
        setCastingData(castingData);
        return true;
      }, (rejection) => {console.log(rejection); return false;});
    }

  }, (rejection) => {console.log(rejection); return false;})

}

const getBookedAuditionees = async(slots, organisationId, setAuditionees) => {

  let auditioneeData = await Promise.all(slots.map(async (slot) => {

    if(slot.auditionee_id !== null)
    {
      const docRef = _getAuditioneeDocRef(organisationId, slot.auditionee_id);
      try {
        const qDoc = await getDoc(docRef);
        const data = qDoc.data();
        return data;
      } 
      catch (err) 
      {
        console.error(err);
        return ({
          uid: Math.random().toString(36).substring(2, 10),
          name: 'N/A',
          email: 'N/A',
          phone: 'N/A',
          error: true
        })
      };
    }

  }))

  const filteredAuditioneeData = auditioneeData.filter((x) => {return x !== undefined})

  setAuditionees(filteredAuditioneeData);
}

const getAuditionee = async(email, organisationId) => {
  const auditionee = await _getAuditioneeByEmail(organisationId, email);
  return auditionee;
}

async function checkAuditioneeByEmail(email, organisationId) {
  const fn = httpsCallable(functions, 'checkAuditioneeByEmail');

  const result = await fn({
    email,
    organisationId
  });

  return result.data;
}

const updateAuditionSlot = async(newSlot, slots, organisationId, projectId, setSlots, setAuditionees, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get updated slots
  await _getCastingData(docRef).then(async(castingData) => {

    // If the current slots are different to the local slots, we will refresh the auditionee pool at the end of the function
    const slotsChanged = (slots === castingData.slots);

    var newSlots = [...castingData.slots];
    newSlots.forEach((slot, i) => {
      if(slot.id === newSlot.id) { newSlots[i] = newSlot; };
    })

    await setDoc(docRef, {slots: newSlots}, {merge: true}).then(async() => {
      if(slotsChanged) {
        await Promise.resolve(getBookedAuditionees(newSlots, organisationId, setAuditionees));
        console.log("Data received");
      }
      console.log("Moving on");
      setSlots(newSlots);
      castingData.slots = newSlots;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.error(rejection); return false;});

  }, (rejection) => {console.error(rejection); return false;});
}

const addUnbookedAudition = async(auditionee, organisationId, projectId, setCastingData) => {
  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get a new copy of casting data
  await _getCastingData(docRef).then(async(castingData) => {

    const newSlot = {
      id: _getId(castingData.slots),
      time_id: null,
      auditionee_id: auditionee.uid,
      date: 'Unbooked Auditions',
      start: '',
      location: '',
      recalled: false,
      notes: {
        audition_verdict: 'undetermined',
        recall_verdicts: []
      }
    }

    // Create new audition slots
    const newSlots = [...castingData.slots, newSlot];

    // Send new roles and audition times back to the server
    await setDoc(docRef, {slots: newSlots}, {merge: true}).then(() => {
      castingData.slots = newSlots;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.log(rejection); return false;});

  }, (rejection) => {console.log(rejection); return false;});
}

const deleteUnbookedAudition = async(slot, slots, organisationId, projectId, setSlots, setAuditionees, setCastingData) => {
  
  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get updated slots
  await _getCastingData(docRef).then(async(castingData) => {

    const id = slot.id;
    var newRoles = castingData.roles;

    if(slot.recalled) {
      newRoles = removeUserFromChoicesForAllRoles(castingData.roles, slot.auditionee_id);
      if(slot.notes.recall_verdicts.length > 0) {
        alert(slot.auditionee_id + ' has been removed from all recall groups they were added to');
      }
    }

    // If the current slots are different to the local slots, we will refresh the auditionee pool at the end of the function
    const slotsChanged = (slots === castingData.slots);
    var newSlots = castingData.slots.filter((x) => {return x.id !== id})

    await setDoc(docRef, {slots: newSlots, roles: newRoles}, {merge: true}).then(async() => {
      if(slotsChanged) {
        await Promise.resolve(getBookedAuditionees(newSlots, organisationId, setAuditionees));
        console.log("Data received");
      }
      console.log("Moving on");
      setSlots(newSlots);
      castingData.slots = newSlots;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.error(rejection); return false;});

  }, (rejection) => {console.error(rejection); return false;});

}

const createAuditionee = async(auditionee, organisationId) => {
  const docRef = _getAuditioneeDocRef(organisationId, auditionee.uid);

  try
  {
    await setDoc(docRef, auditionee);
    return true;
  }
  catch(err)
  {
    alert('Could not create auditionee');
    console.error(err);
    return false;
  }
}

const createGroup = async(recalleeData, organisationId, projectId, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get a new copy of casting data
  await _getCastingData(docRef).then(async(castingData) => {

    var newSlots = castingData.slots;
    var newRoles = castingData.roles;
    const groupId = uuidv4();

    recalleeData.forEach((recallee) => {
      
      newSlots.forEach((slot, index) => {
        if(slot.auditionee_id === recallee.auditionee_id) {
          // If this is the first group they are being added to, they need to be removed as a choice for every role bar this
          if(newSlots[index].notes.recall_verdicts.length === 0)
          {
            const keepMap = [recallee.role_id];
            console.log("Calling removeUserFromChoicesForSelectedRoles with keepMap ", keepMap);
            newRoles = _removeUserFromChoicesForSelectedRoles(castingData.roles, keepMap, slot.auditionee_id);
          }
          newSlots[index].notes.recall_verdicts = [...newSlots[index].notes.recall_verdicts,
            {
              group_id: groupId,
              role_id: recallee.role_id,
              verdict: 'undetermined'
            }
          ]
        }
      })
    })

    // Send new roles back to the server
    await setDoc(docRef, {slots: newSlots, roles: newRoles}, {merge: true}).then(() => {
      castingData.slots = newSlots;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.log(rejection); return false;});

  }, (rejection) => {console.log(rejection); return false;});
}

const deleteGroup = async(groupId, organisationId, projectId, setSlots, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);
  function removeMarkedEntries(x) {return (x.marked_for_deletion !== true)};

  // Get a new copy of casting data
  await _getCastingData(docRef).then(async(castingData) => {

    var newSlots = castingData.slots;
    var newRoles = castingData.roles;

    newSlots.forEach((slot, i) => {
      var rolesToCheckForChoices = [];
      
      slot.notes.recall_verdicts.forEach((recall, index) => {
        if(recall.group_id === groupId)
        {
          rolesToCheckForChoices.push(recall.role_id);
          recall.marked_for_deletion = true;
        }
      })

      slot.notes.recall_verdicts = slot.notes.recall_verdicts.filter(removeMarkedEntries);
      newSlots[i] = slot;

      // If there are roles to remove, and the user is still a part of certain groups, then we remove them
      if(rolesToCheckForChoices.length > 0 && slot.notes.recall_verdicts.length > 0)
      {
        rolesToCheckForChoices.forEach((roleId) => {
          newRoles = _removeUserFromChoicesForRole(roleId, newRoles, slot.auditionee_id);
        })
      }
    })

    console.log("DATA:", newSlots, "AND", newRoles);

    // Send new slots back to the server
    await setDoc(docRef, {slots: newSlots, roles: newRoles}, {merge: true}).then(() => {
      setSlots(newSlots);
      castingData.slots = newSlots;
      castingData.roles = newRoles;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.log(rejection); return false;});

  }, (rejection) => {console.log(rejection); return false;});

}

const setRecallVerdict = async(verdict, recalleeId, groupId, organisationId, projectId, setSlots, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get a new copy of casting data
  await _getCastingData(docRef).then(async(castingData) => {

    var newSlots = castingData.slots;

    newSlots.forEach((slot) => {
      if(slot.auditionee_id === recalleeId) {
        slot.notes.recall_verdicts.forEach((recall) => {
          if(recall.group_id === groupId) {
            recall.verdict = verdict;
          }
        })
      }
    })

    // Send new slots back to the server
    await setDoc(docRef, {slots: newSlots}, {merge: true}).then(() => {
      setSlots(newSlots);
      castingData.slots = newSlots;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.log(rejection); return false;});

  }, (rejection) => {console.log(rejection); return false;});

}

const setCastingChoice = async(roleId, choiceIndex, value, organisationId, projectId, setCastingData) => {

  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get a new copy of casting data
  await _getCastingData(docRef).then(async(castingData) => {
    
    const newRoles = castingData.roles;
    newRoles.forEach(role => {
      if(role.id === roleId)
      {
        role.choices[choiceIndex] = (value === '')? null : value;
      }
    })

    // Send new roles back to the server
    await setDoc(docRef, {roles: newRoles}, {merge: true}).then(() => {
      castingData.roles = newRoles;
      setCastingData(castingData);
      return true;
    }, (rejection) => {console.log(rejection); return false;});

  }, (rejection) => {console.log(rejection); return false;});
}

const removeUserFromChoicesForAllRoles = (roles, removedAuditioneeId) => {
  var newRoles = roles;
  roles.forEach(role => {
    newRoles = _removeUserFromChoicesForRole(role.id, newRoles, removedAuditioneeId, true);
  })
  return newRoles;
}

const bookAudition = async(auditionee, slot, projectData, time, organisationId, setBookingConfirmed) => {

  const slotId = slot.id;
  const showName = projectData.name;
  const projectId = projectData.uid;
  const docRef = _getCastingDocRef(organisationId, projectId);

  // Get updated slots
  await _getCastingData(docRef).then(async(castingData) => {

    var newSlots = castingData.slots;

    newSlots.forEach(slot => {
      if(slot.id === slotId) {
        if(castingData.booking_enabled === false)
        {
          alert('Booking is no longer open');
          window.location.reload();
        }
        if(slot.auditionee_id !== null)
        {
          alert('This audition slot is no longer available');
          window.location.reload();
        }
        else
        {
          slot.auditionee_id = auditionee.uid;
        }
      }
    })

    await setDoc(docRef, {slots: newSlots}, {merge: true}).then(async() => {
      const mailRef = collection(db, 'mail');
      // Send confirmation email to auditionee
      await addDoc(mailRef, {
        to: auditionee.email,
        message: {
          subject: `Your '${showName}' Audition`,
          html: `Hi ${auditionee.name}.<br/><br/>This email is to confirm that your audition for <b>'${showName}'</b> has been booked for:<br/>
                <br/>
                <b>${slot.start} on ${PrettifyDate(time.date)} in ${time.location}</b>.<br/>
                <br/>
                If there are any issues with your booking, please contact the <i>${showName}</i> team.<br/>
                <br/>
                Many thanks,<br/>
                CastingBot<br/><br/>
                <small>(This is an automated email. Responses will not be seen.)</small>`
        }
      })

      // Send an email to all project managing recipients
      await addDoc(mailRef, {
        toUids: projectData.email_recipients,
        message: {
          subject: `New Audition Booked For '${showName}'`,
          html: `Hi.<br/><br/>
                ${auditionee.name} <i>(${auditionee.email})</i> has just booked an audition for '${showName}' at:<br/>
                <br/>
                <b>${slot.start} on ${PrettifyDate(time.date)} in ${time.location}.</b><br/>
                <br/>
                You can view all your auditionees at <a href="${window.location.origin}/console/auditions">${window.location.origin}/console/auditions</a><br/>
                <br/>
                Many thanks,<br/>
                CastingBot<br/><br/>
                <small>(This is an automated email. Responses will not be seen.)</small>`
        }
      })

      setBookingConfirmed(true);
      return true;
    }, (rejection) => {console.error(rejection); return false;});

  }, (rejection) => {console.error(rejection); return false;});
}

const createAuditioneeAndBookAudition = async(email, firstName, lastName, phone, slot, projectData, time, organisationId, setBookingConfirmed) => {
  
  const uid = Math.random().toString(36).substring(2, 10);

  const auditionee = {
    uid: uid,
    email: email,
    name: firstName + ' ' + lastName,
    phone: phone
  }

  await createAuditionee(auditionee, organisationId).then(() => {
    bookAudition(auditionee, slot, projectData, time, organisationId, setBookingConfirmed);
  }, (rejection) => {console.error(rejection); alert('Could not book audition')})
}




export {
  setBookingEnabled,

  addRole,
  deleteRole,
  setRoles,

  addTime,
  deleteTime,

  getBookedAuditionees,
  getAuditionee,
  checkAuditioneeByEmail,
  updateAuditionSlot,
  addUnbookedAudition,
  deleteUnbookedAudition,
  createAuditionee,
  createGroup,
  deleteGroup,
  setRecallVerdict,
  setCastingChoice,
  removeUserFromChoicesForAllRoles,

  bookAudition,
  createAuditioneeAndBookAudition
}





const _getCastingDocRef = (organisationId, projectId) => {
  return doc(db, organisationId, 'castingbot', 'projects', projectId);
}

const _getAuditioneeDocRef = (organisationId, auditioneeId) => {
  return doc(db, organisationId, 'castingbot', 'auditionees', auditioneeId);
}

const _getAuditioneeByEmail = async(organisationId, email) => {
  const q = query(
    collection(db, organisationId, 'castingbot', 'auditionees'),
    where('email', '==', email)
  );
  const snap = await getDocs(q);
  if(snap.empty) return null;
  return snap.docs[0].data();
}

const _getCastingData = async(docRef) => {
  try {
    const qDoc = await getDoc(docRef);
    const data = qDoc.data();
    return data;
  } 
  catch (err) 
  {
    console.error(err);
    alert(err);
    logout();
  };
}

const _getId = (items) => {
  var id = 0;
  items.forEach(item => {
    if(item.id >= id) id = item.id + 1;
  });
  return id;
}

const _getTimeAsNumber = (time) => {
  const timeArray = time.split(':');
  return (parseInt(timeArray[0] * 60) + parseInt(timeArray[1]))
}

const _addAuditionsFromTime = (time, time_id, slots) => {

  // Convert data for use in slot creation
  const start = _getTimeAsNumber(time.start);
  const end = _getTimeAsNumber(time.end);
  const slotLength = parseInt(time.slot_length);

  var index = 0;
  var currentTime = start;
  while(currentTime < end)
  {
    console.log("Slot Start: " + currentTime + ", Slot End: " + (currentTime + slotLength) + ", Master End: " + end);
    slots = [...slots, {
      id: (time_id + '_' + index),
      time_id: time_id,
      auditionee_id: null,
      date: time.date,
      start: Math.floor(currentTime/60) + ":" + (("00" + (currentTime%60)).slice(-2)),
      location: time.location,
      recalled: false,
      notes: {
        audition_verdict: 'undetermined',
        recall_verdicts: []
      }
    }]
    currentTime = currentTime + slotLength;
    console.log("New Current Time: " + currentTime);
    index++;
  }

  return slots;
}

// keepmap should be given as an array of string IDs, storing the roles you wish to not remove the auditionee as a choice from
const _removeUserFromChoicesForSelectedRoles = (roles, keepMap, removedAuditioneeId) => {
  var newRoles = roles;
  roles.forEach(role => {
    if(keepMap.includes(role.id.toString()) === false)
    {
      newRoles = _removeUserFromChoicesForRole(role.id, newRoles, removedAuditioneeId, true);
    }
  })
  console.log(newRoles);
  return newRoles;
}

const _removeUserFromChoicesForRole = (roleId, roles, removedAuditioneeId, alertUser) => {
  const newRoles = roles;
  newRoles.forEach((r) => {
    if(r.id.toString() === roleId.toString()) {
      r.choices.forEach((choice, index) => {
        if(choice === removedAuditioneeId) 
        {
          r.choices[index] = null;
          if(alertUser === true) alert(removedAuditioneeId + ' has been removed as a casting choice for ' + r.name + ', as they are no longer in a group for that role');
        }
      })
    }
  })
  return newRoles;
}